(() => {
  const originalFetch = window.fetch.bind(window);

  const OMI_VARIANTS = new Set([59365187125573,59365187158341,59365187191109,59365187223877,59365187256645,59365187289413,59365187322181,59365187354949,59365187387717,59365187420485,59365187453253,59365187486021,59365187518789,59365187551557,59365187584325,59365187617093,59365187649861,59365187682629,59365187715397,59365187748165,59365187780933,59365187813701,59365187846469,59365187879237,59365187912005,59365187944773,59365187977541,59365188010309,59365188043077,59365188075845,59365188108613,59365188141381,59365188174149,59365188206917,59365188239685,59365188272453,59365188305221,59365188337989,59365188370757,59365188403525,59365188436293,59365188469061]);
  function isCartAddRequest(input, init) {
    try {
      const rawUrl = typeof input === 'string' ? input : input && input.url;
      const url = new URL(rawUrl, window.location.origin);
      const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      return method === 'POST' && url.origin === window.location.origin && url.pathname.includes('/cart/add');
    } catch (_) {
      return false;
    }
  }

  window.fetch = async function (...args) {
    const response = await originalFetch(...args);
    if (response.ok && isCartAddRequest(args[0], args[1]) && !window.__omiPackAdding && !window.location.pathname.startsWith('/cart')) {
      setTimeout(() => {
        if (!window.location.pathname.startsWith('/cart')) window.location.assign('/cart');
      }, 500);
    }
    return response;
  };

  function money(cents) {
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function estimateCart(cart) {
    for (const item of cart.items || []) {
      if (!OMI_VARIANTS.has(Number(item.variant_id))) return null;
    }
    const subtotal = Number(cart.total_price || 0);
    if (subtotal >= 3900) return 0;
    if (subtotal >= 3000) return 299;
    if (subtotal >= 1500) return 399;
    return 349;
  }

  function ensureStyles() {
    if (document.getElementById('omi-cart-shipping-styles')) return;
    const style = document.createElement('style');
    style.id = 'omi-cart-shipping-styles';
    style.textContent = `
      .omi-cart-shipping-details{
        width:100%;margin:12px 0 4px;padding:15px 16px;border-radius:14px;
        border:1px solid rgba(203,170,112,.35);
        background:linear-gradient(145deg,rgba(203,170,112,.12),rgba(20,19,24,.4));
        color:#f7f3ec;box-sizing:border-box
      }
      .omi-cart-shipping-inline,.omi-cart-total-estimate{
        display:flex;justify-content:space-between;align-items:center;gap:12px;
        width:100%;font-size:13px;line-height:1.5;color:#f7f3ec;text-align:left
      }
      .omi-cart-shipping-inline strong,.omi-cart-total-estimate strong{font-weight:750;color:#eddaa7;white-space:nowrap}
      .omi-cart-shipping-message{margin-top:13px;font-size:12px;line-height:1.5;color:#f7f3ec}
      .omi-cart-shipping-message strong{color:#eddaa7}
      .omi-cart-shipping-progress{height:7px;margin-top:8px;overflow:hidden;
        border-radius:999px;background:rgba(247,243,236,.13)}
      .omi-cart-shipping-progress span{display:block;height:100%;
        border-radius:999px;background:linear-gradient(90deg,#bd9558,#eddaa7);transition:width .25s ease}
      .omi-cart-total-estimate{padding-top:12px;margin-top:13px;
        border-top:1px solid rgba(203,170,112,.3);font-weight:650}
      .omi-cart-pickup-inline{margin:9px 0 0;font-size:11px;line-height:1.5;color:#ded3bd;text-align:left}
      .omi-cart-shipping-disclaimer{margin:5px 0 0;font-size:10px;line-height:1.45;color:#bfb5aa}
      .omi-cart-pack-details{border-color:rgba(221,182,125,.65)}
      .omi-cart-promo-message{margin:11px 0 13px;font-size:11px;line-height:1.6;color:#f4d6d3}
      .omi-cart-pack-again{display:inline-block;margin-top:12px;color:#eddaa7!important;font-size:11px;text-decoration:underline!important}

      /* Pack OMI: un solo artículo visual, desglose de referencias sin precios individuales */
      .cart-items__table-row .omi-represent-normal-price > :not(.omi-regular-unit-price){display:none!important}
      .cart-items__table-row .omi-represent-normal-price .omi-regular-unit-price{display:inline-block!important;color:inherit;font-weight:600}
      .cart-items__table-row.omi-represent-normal-discount .cart-items__variants-wrapper ul[role="list"]{display:none!important}
      .cart-items__table-row.omi-hidden-pack-item{display:none!important}
      .cart-items__table-row.omi-pack-display-row{display:table-row!important}
      .omi-pack-display-row>td.omi-pack-card-cell{padding:12px 0 22px!important;border:0!important;width:100%;max-width:100%}
      .omi-pack-card{display:grid;grid-template-columns:155px minmax(0,1fr);gap:24px;width:100%;padding:22px;border:1px solid rgba(202,166,105,.43);background:linear-gradient(115deg,#211d22,#100f14 88%);color:#f6efe6;box-sizing:border-box}
      .omi-pack-card__photo{width:100%;height:185px;object-fit:contain;filter:drop-shadow(0 12px 17px rgba(0,0,0,.42))}
      .omi-pack-card__eyebrow{margin:0 0 10px;font-size:10px;letter-spacing:.18em;font-weight:750;color:#dab883}
      .omi-pack-card__main{display:flex;gap:22px;align-items:start;justify-content:space-between}
      .omi-pack-card h3{margin:0 0 7px;font:400 clamp(22px,2.2vw,30px)/1.1 Georgia,serif;letter-spacing:-.02em;color:#faf4e9}
      .omi-pack-card__subtitle{margin:0 0 12px;font-size:11px;color:#d5c3b8}
      .omi-pack-card__price{flex:none;text-align:right;white-space:nowrap;display:flex;flex-direction:column;align-items:end;gap:5px}
      .omi-pack-card__price s{font-size:14px;color:#ad9d9c}
      .omi-pack-card__price strong{font:400 30px Georgia,serif;color:#e9c391}
      .omi-pack-card__price span{font-size:9px;color:#d7adaf;letter-spacing:.05em}
      .omi-pack-card__list{list-style:none;margin:0 0 14px;padding:0;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:7px 13px}
      .omi-pack-card__list li{font-size:11px;line-height:1.6;color:#e7dcd3;overflow-wrap:anywhere}
      .omi-pack-card__remove{background:transparent;border:0;border-bottom:1px solid rgba(213,189,162,.6);padding:4px 0;color:#e3c5a5;letter-spacing:.08em;font-size:10px;font-weight:750;cursor:pointer}
      .omi-pack-card__remove:disabled{opacity:.5;cursor:wait}
      @media(max-width:749px){
        .omi-pack-card{grid-template-columns:82px minmax(0,1fr);gap:13px;padding:13px}
        .omi-pack-card__photo{height:125px}
        .omi-pack-card__main{display:block}
        .omi-pack-card h3{font-size:23px}
        .omi-pack-card__price{display:flex;flex-direction:row;justify-content:flex-start;align-items:center;gap:10px;margin:11px 0}
        .omi-pack-card__price strong{font-size:26px}
        .omi-pack-card__list{grid-template-columns:1fr;gap:3px}
        .omi-pack-card__list li{font-size:10px}
      }
      @media(max-width:749px){
        .omi-cart-shipping-details{padding:13px 14px}
        .omi-cart-shipping-inline,.omi-cart-total-estimate{font-size:12px}
      }
    `;
    document.head.appendChild(style);
  }

  function translateCartLabels(root = document) {
    const elements = root.querySelectorAll ? root.querySelectorAll('h1,h2,h3,h4,h5,h6,a,button') : [];
    elements.forEach((el) => {
      const text = el.textContent.trim().toLowerCase();
      if (text === 'cart') el.textContent = 'Carrito';
      else if (text === 'you may also like') el.textContent = 'También te puede gustar';
      else if (text === 'view all') el.textContent = 'Ver todo';
    });
  }


  // Los packs siguen siendo referencias OMI reales (para stock); aquí se muestran como una ficha.
  let currentPackLines = new Map();
  let removingPack = false;
  function identifyPacks(cart){
    const groups=new Map();
    for(const item of cart.items||[]){
      const id=String((item.properties&&item.properties._OMI_Pack)||'');
      if(!id || !OMI_VARIANTS.has(Number(item.variant_id)))continue;
      if(!groups.has(id))groups.set(id,[]);
      groups.get(id).push(item);
    }
    const valid=new Map();
    for(const [id,items] of groups){
      if(items.reduce((sum,item)=>sum+Number(item.quantity||0),0)===4)valid.set(id,items);
    }
    // Compatibilidad con una prueba anterior de cuatro perfumes creada sin etiquetas de pack.
    if(valid.size===0 && groups.size===0 &&
      String((cart.attributes&&cart.attributes.OMI_Lanzamiento)||'')==='1x4' &&
      Number(cart.item_count)===4 && (cart.items||[]).every(item=>OMI_VARIANTS.has(Number(item.variant_id)))){
      valid.set('omi-legacy',(cart.items||[]).slice());
    }
    return valid;
  }

  function renderPackCards(cart){
    const body=document.querySelector('.cart-items__table tbody');
    if(!body)return;
    const groups=identifyPacks(cart);
    const groupedKeys=new Set();
    for(const items of groups.values())for(const item of items)groupedKeys.add(item.key);
    const ungrouped=(cart.items||[]).filter(item=>!groupedKeys.has(item.key));
    const expectedTotal=groups.size*2000 + ungrouped.reduce((sum,item)=>sum+Number(item.original_line_price||0),0);
    // Mostrar el pack a 20 € solo si la suma del pack y los sueltos coincide exactamente con el cobro real.
    const priceMatches=groups.size>0 && expectedTotal===Number(cart.total_price);
    if(!priceMatches)groups.clear();
    currentPackLines=groups;
    const rowByKey=new Map();
    body.querySelectorAll('tr.cart-items__table-row[data-key]').forEach(row=>{
      if(!row.classList.contains('omi-pack-display-row'))rowByKey.set(row.getAttribute('data-key'),row);
    });
    const keys=new Set();
    for(const items of groups.values())for(const item of items)keys.add(item.key);
    const itemByKey=new Map((cart.items||[]).map(item=>[item.key,item]));
    for(const [key,row] of rowByKey){
      const hide=keys.has(key);
      if(row.classList.contains('omi-hidden-pack-item')!==hide){
        row.classList.toggle('omi-hidden-pack-item',hide);
        if(hide)row.setAttribute('aria-hidden','true');
        else row.removeAttribute('aria-hidden');
      }
      const item=itemByKey.get(key);
      const restoreNormal=priceMatches && !hide && item &&
        Number(item.final_line_price)!==Number(item.original_line_price);
      for(const selector of ['.cart-items__unit-price-wrapper','.cart-items__price']){
        const target=row.querySelector(selector);
        if(!target)continue;
        const existing=target.querySelector('.omi-regular-unit-price');
        if(restoreNormal){
          if(!existing){
            const value=document.createElement('span');
            value.className='omi-regular-unit-price';
            target.appendChild(value);
          }
          const value=target.querySelector('.omi-regular-unit-price');
          value.textContent=money(selector.includes('unit')?item.original_price:item.original_line_price);
          target.classList.add('omi-represent-normal-price');
        }else{
          if(existing)existing.remove();
          target.classList.remove('omi-represent-normal-price');
        }
      }
      row.classList.toggle('omi-represent-normal-discount',Boolean(restoreNormal));
    }
    const signature=JSON.stringify(Array.from(groups,([id,items])=>[
      id,items.map(item=>[item.key,item.quantity,item.final_line_price])
    ]));
    if(body.dataset.omiPackSignature===signature &&
       body.querySelectorAll('tr.omi-pack-display-row').length===groups.size)return;

    body.querySelectorAll('tr.omi-pack-display-row').forEach(row=>row.remove());
    const fragment=document.createDocumentFragment();
    for(const [id,items] of groups){
      const row=document.createElement('tr');
      row.className='cart-items__table-row omi-pack-display-row';
      row.setAttribute('role','row');
      row.dataset.omiPackId=id;
      const cell=document.createElement('td');
      cell.className='omi-pack-card-cell';
      cell.setAttribute('colspan','4');
      cell.setAttribute('role','cell');
      const card=document.createElement('div');
      card.className='omi-pack-card';
      const photo=document.createElement('img');
      photo.className='omi-pack-card__photo';
      photo.src='https://cdn.shopify.com/s/files/1/1097/0480/6725/files/omi-parfum-botellas-transparentes.png?v=1789550451';
      photo.alt='Botellas originales OMI Parfum';
      photo.loading='lazy';
      const content=document.createElement('div');
      content.className='omi-pack-card__content';
      const eyebrow=document.createElement('p');
      eyebrow.className='omi-pack-card__eyebrow';
      eyebrow.textContent='OMI PARFUM · EDICIÓN LANZAMIENTO';
      const main=document.createElement('div');
      main.className='omi-pack-card__main';
      const titleWrap=document.createElement('div');
      const title=document.createElement('h3');
      title.textContent='Pack de 4 perfumes';
      const sub=document.createElement('p');
      sub.className='omi-pack-card__subtitle';
      sub.textContent='4 aromas de 30 ml · elegidos por ti';
      titleWrap.append(title,sub);
      const price=document.createElement('div');
      price.className='omi-pack-card__price';
      const oldPrice=document.createElement('s');oldPrice.textContent='24,00 €';
      const newPrice=document.createElement('strong');newPrice.textContent='20,00 €';
      const saving=document.createElement('span');saving.textContent='AHORRAS 4 €';
      price.append(oldPrice,newPrice,saving);
      main.append(titleWrap,price);
      const list=document.createElement('ul');
      list.className='omi-pack-card__list';
      for(const item of items){
        const li=document.createElement('li');
        const label=String(item.variant_title||item.title||'OMI Parfum');
        li.textContent=Number(item.quantity||1)+' × '+label.replace(/^OMI Parfum 30 ml\\s*[-–—:]?\\s*/i,'');
        list.appendChild(li);
      }
      const remove=document.createElement('button');
      remove.type='button';
      remove.className='omi-pack-card__remove';
      remove.dataset.omiRemovePack=id;
      remove.textContent='QUITAR PACK COMPLETO';
      content.append(eyebrow,main,list,remove);
      card.append(photo,content);
      cell.appendChild(card);row.appendChild(cell);fragment.appendChild(row);
    }
    body.insertBefore(fragment,body.firstChild);
    body.dataset.omiPackSignature=signature;
  }

  function bindPackRemoval(){
    document.addEventListener('click',async event=>{
      const button=event.target.closest('[data-omi-remove-pack]');
      if(!button||removingPack||!window.location.pathname.startsWith('/cart'))return;
      const lines=currentPackLines.get(button.dataset.omiRemovePack);
      if(!lines||!lines.length)return;
      removingPack=true;button.disabled=true;button.textContent='QUITANDO PACK…';
      try{
        const updates={};
        for(const item of lines)updates[item.key]=0;
        const response=await originalFetch('/cart/update.js',{
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({updates})
        });
        if(!response.ok)throw new Error('No se ha podido quitar el pack.');
        const changed=await response.json();
        const remaining=Array.from(identifyPacks(changed)).length;
        if(remaining===0){
          await originalFetch('/cart/update.js',{
            method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({discount:'',attributes:{OMI_Lanzamiento:''}})
          });
        }else{
          await originalFetch('/cart/update.js',{
            method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({attributes:{OMI_Lanzamiento:String(remaining)+'x4'}})
          });
        }
        window.location.reload();
      }catch(_){
        removingPack=false;button.disabled=false;button.textContent='QUITAR PACK COMPLETO';
        window.alert('No se ha podido quitar el pack. Inténtalo de nuevo.');
      }
    });
  }

  let rendering = false;
  async function renderEstimate() {
    if (!window.location.pathname.startsWith('/cart') || rendering) return;
    const totals = document.querySelector('.cart-totals__container');
    if (!totals) return;
    const totalRow = totals.querySelector('.cart-totals__total');
    if (!totalRow) return;
    rendering = true;
    try {
      const response = await originalFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      renderPackCards(cart);
      let box = document.getElementById('omi-cart-shipping-estimate');
      if (!cart.item_count) {
        if (box) box.remove();
        return;
      }
      const estimate = estimateCart(cart);
      if (!box) {
        box = document.createElement('div');
        box.id = 'omi-cart-shipping-estimate';
        totalRow.insertAdjacentElement('afterend', box);
      } else if (box.previousElementSibling !== totalRow) {
        totalRow.insertAdjacentElement('afterend', box);
      }
      const subtotal = Number(cart.total_price || 0);
      const promoMarker = String((cart.attributes && cart.attributes.OMI_Lanzamiento) || '');
      const promoMatch = /^([1-6])x4$/.exec(promoMarker);
      const promoPacks = promoMatch ? Number(promoMatch[1]) : 0;
      const isPromoCart = promoPacks > 0 &&
        Number(cart.item_count) === promoPacks * 4 &&
        (cart.items || []).every((item) => OMI_VARIANTS.has(Number(item.variant_id)));
      let html;
      if (isPromoCart) {
        const promoSubtotal = promoPacks * 2000;
        const promoShipping = estimateCart({ ...cart, total_price: promoSubtotal });
        const remaining = Math.max(0, 3900 - promoSubtotal);
        const progress = Math.min(100, Math.round(promoSubtotal / 3900 * 100));
        const discountNotice = subtotal <= promoSubtotal
          ? 'Descuento de lanzamiento aplicado.'
          : 'El descuento promocional se comprueba al finalizar el pedido.';
        html = '<div class="omi-cart-shipping-details omi-cart-pack-details">' +
          '<div class="omi-cart-shipping-inline"><span>PACK DE LANZAMIENTO · ' + promoPacks + ' × 4 PERFUMES</span><strong>' + money(promoSubtotal) + '</strong></div>' +
          '<p class="omi-cart-promo-message">' + discountNotice + '</p>' +
          '<div class="omi-cart-shipping-inline"><span>Envío estimado · Península</span><strong>' + (promoShipping === 0 ? 'Gratis' : money(promoShipping)) + '</strong></div>' +
          '<div class="omi-cart-shipping-message">' + (remaining === 0 ? '<strong>¡Ya tienes envío gratis!</strong>' : 'Te faltan <strong>' + money(remaining) + '</strong> para envío gratis') + '</div>' +
          '<div class="omi-cart-shipping-progress" role="progressbar" aria-label="Progreso hacia el envío gratis" aria-valuemin="0" aria-valuemax="39" aria-valuenow="' + Math.min(39, promoSubtotal / 100).toFixed(2) + '"><span style="width:' + progress + '%"></span></div>' +
          '<div class="omi-cart-total-estimate"><span>Total promocional previsto con envío</span><strong>' + money(promoSubtotal + promoShipping) + '</strong></div>' +
          '<p class="omi-cart-pickup-inline">Recogida en tienda · Gratis</p>' +
          '<p class="omi-cart-shipping-disclaimer">El descuento y el envío definitivo se confirman en el pago. Si el total no coincide, no finalices la compra.</p>' +
          '</div>';
      } else if (estimate === null) {
        html = '<div class="omi-cart-shipping-details"><div class="omi-cart-shipping-inline">Envío calculado al finalizar el pedido</div><p class="omi-cart-shipping-disclaimer">El importe depende de los productos y del destino.</p></div>';
      } else {
        const remaining = Math.max(0, 3900 - subtotal);
        const progress = Math.min(100, Math.round((subtotal / 3900) * 100));
        const progressValue = Math.min(39, Math.max(0, subtotal / 100)).toFixed(2);
        const shippingText = estimate === 0 ? 'Gratis' : money(estimate);
        const message = remaining === 0
          ? '<strong>¡Ya tienes envío gratis!</strong>'
          : `Te faltan <strong>${money(remaining)}</strong> para el envío gratis`;
        html = `
          <div class="omi-cart-shipping-details">
            <div class="omi-cart-shipping-inline"><span>Envío estimado · Península</span><strong>${shippingText}</strong></div>
            <div class="omi-cart-shipping-message">${message}</div>
            <div class="omi-cart-shipping-progress" role="progressbar" aria-label="Progreso hacia envío gratis" aria-valuemin="0" aria-valuemax="39" aria-valuenow="${progressValue}">
              <span style="width:${progress}%"></span>
            </div>
            <div class="omi-cart-total-estimate"><span>Total estimado con envío</span><strong>${money(subtotal + estimate)}</strong></div>
            <p class="omi-cart-pickup-inline">Recogida en tienda · Gratis</p>
            <p class="omi-cart-shipping-disclaimer">Estimación para España peninsular. El coste definitivo se confirma al finalizar el pedido.</p>
          </div>`;
      }
      const renderKey = `${subtotal}:${estimate}:${promoMarker}:${cart.item_count}`;
      if (box.dataset.omiRenderKey !== renderKey) {
        box.innerHTML = html;
        box.dataset.omiRenderKey = renderKey;
      }
    } catch (_) {
      // El checkout confirma el importe final según el destino.
    } finally {
      rendering = false;
    }
  }

  function initCartEnhancements() {
    ensureStyles();
    translateCartLabels(document);
    if (window.location.pathname.startsWith('/cart')) bindPackRemoval();
    renderEstimate();

    if (!window.location.pathname.startsWith('/cart') || !window.MutationObserver) return;
    let timer;
    const root = document.getElementById('MainContent') || document.body;
    const observer = new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        translateCartLabels(root);
        renderEstimate();
      }, 300);
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCartEnhancements, { once: true });
  else initCartEnhancements();
})();